const initialState = {
  status: "invalid",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "STATIC_PAGE_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "STATIC_PAGE_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action
      };
    case "STATIC_PAGE_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
